module.exports = __webpack_public_path__ + "img/planta_10.ccd52932.png";